import { useState } from 'react';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

/**
 * @hook useMultiSelectFilter
 * @type {import('$types/components/hooks/filters.d.ts').UseMultiSelectFilter}
 */
const useMultiSelectFilter = (params = {}) => {
    const [value, setValue] = useState(params.value || []);
    const options = params.options || [];

    /** @type {(key: string) => void} */
    const addValue = (key) => {
        setValue([...value, key]);
    };

    /** @type {(key: string) => void} */
    const removeValue = (key) => {
        let values = [...value];
        const index = values.indexOf(key);
        if (index > -1) { values.splice(index, 1); }
        setValue(values);
    };

    /** @type {(key: string) => void} */
    const toggleValue = (key) => {
        if (value.indexOf(key) === -1) {
            addValue(key);
        } else {
            removeValue(key);
        }
    };

    return {
        addValue,
        options,
        removeValue,
        setValue,
        toggleValue,
        value
    };
};


/**
 * @hook useMultiSelectFilter
 * @type {import('$types/components/hooks/filters.d.ts').UseSingleSelectFilter}
 */
const useSingleSelectFilter = (params = {}) => {
    const [value, setValue] = useState(params.value || null);
    const options = params.options || [];

    return {
        options,
        value,
        setValue
    };
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export {
    useMultiSelectFilter,
    useSingleSelectFilter
};
